export const translations = {
  en: {
    // generic
    appName: "MobileZone",
    orgSuite: "Accessories That Connect You",
    login: "Login", logout: "Logout", email: "Email", password: "Password",
    username: "Username", rememberMe: "Remember me", forgotPassword: "Forgot password?",
    signIn: "Sign In", signingIn: "Signing in...", welcomeBack: "Welcome back",
    loginSubtitle: "Sign in to access your organization workspace",
    language: "Language", theme: "Theme", search: "Search",
    save: "Save", cancel: "Cancel", create: "Create", edit: "Edit", delete: "Delete",
    disable: "Disable", enable: "Enable", view: "View", actions: "Actions", status: "Status",
    active: "Active", inactive: "Inactive", confirm: "Confirm", close: "Close",
    export: "Export CSV", filter: "Filter", all: "All", loading: "Loading...",
    name: "Name", phone: "Phone", location: "Location", address: "Address",
    description: "Description", createdDate: "Created Date", lastLogin: "Last Login",
    // nav
    dashboard: "Dashboard", organization: "Organization", branches: "Branches",
    orgProfile: "Organization Profile", usersAccess: "Users & Access", users: "Users",
    roles: "Roles", permissions: "Permissions", accessControl: "Access Control",
    monitoring: "Monitoring", auditLogs: "Audit Logs", reports: "Reports",
    configuration: "Configuration", settings: "Settings", generalSettings: "General Settings",
    notifications: "Notifications", security: "Security", support: "Support",
    systemInfo: "System Information", profile: "Profile", myProfile: "My Profile",
    // dashboard
    totalBranches: "Total Branches", activeBranches: "Active Branches",
    totalUsers: "Total Users", activeUsers: "Active Users", inactiveUsers: "Inactive Users",
    recentLogins: "Recent Logins", failedLogins: "Failed Logins", recentActivity: "Recent Activity",
    usersByBranch: "Users by Branch", activeVsInactive: "Active vs Inactive Users",
    loginActivity: "Login Activity (7 days)", todayActivity: "Today's Activity",
    branchUsers: "Branch Users", executiveOverview: "Executive Overview",
    orgWideInsights: "Organization-wide insights and metrics",
    salesInventory: "Sales & Inventory", products: "Products", sales: "Sales", inventory: "Inventory",
    newSale: "New Sale", createProduct: "Add Product", editProduct: "Edit Product",
    sku: "SKU", category: "Category", brand: "Brand", price: "Price", cost: "Cost", stock: "Stock", reorderLevel: "Reorder Level",
    lowStock: "Low Stock", totalProducts: "Total Products", totalSales: "Total Sales", revenue: "Revenue",
    todayRevenue: "Today's Revenue", todaySales: "Today's Sales", topProducts: "Top Products",
    revenueByBranch: "Revenue by Branch", salesTrend: "Sales Trend (7 days)", recentSales: "Recent Sales",
    invoice: "Invoice", customer: "Customer", paymentMethod: "Payment", quantity: "Qty", total: "Total",
    addItem: "Add", cart: "Cart", completeSale: "Complete Sale", noProducts: "No products found.", noSales: "No sales recorded yet.",
    adjustStock: "Adjust Stock", salesOverview: "Sales & inventory overview", items: "Items", soldBy: "Sold By", voidSale: "Void Sale",
    // branches
    branchManagement: "Branch Management", createBranch: "Create Branch",
    editBranch: "Edit Branch", branchCode: "Branch Code", branchName: "Branch Name",
    manager: "Manager", noBranches: "No branches have been created yet.",
    // users
    userManagement: "User Management", createUser: "Create User", editUser: "Edit User",
    firstName: "First Name", lastName: "Last Name", role: "Role", branch: "Branch",
    confirmPassword: "Confirm Password", resetPassword: "Reset Password",
    assignRole: "Assign Role", assignBranch: "Assign Branch", noUsers: "No users found.",
    // roles
    roleManagement: "Role Management", createRole: "Create Role", editRole: "Edit Role",
    roleName: "Role Name", systemRole: "System Role", customRole: "Custom Role",
    // context
    organizationView: "Organization View", currentBranch: "Current Branch",
    switchBranch: "Switch Branch", viewAsBranch: "View as Branch",
    superAdminViewing: "SUPER ADMIN — VIEWING",
    selectBranch: "Select Branch", selectBranchDesc: "Choose a branch to continue",
    // misc
    noNotifications: "No notifications.", noAuditRecords: "No audit records found.",
    markAllRead: "Mark all as read", changePassword: "Change Password",
    currentPassword: "Current Password", newPassword: "New Password",
    accountStatus: "Account Status", version: "Version", environment: "Environment",
    databaseStatus: "Database Status", authStatus: "Authentication Status", serverTime: "Server Time",
  },
  sw: {
    appName: "MobileZone",
    orgSuite: "Vifaa Vinavyokuunganisha",
    login: "Ingia", logout: "Ondoka", email: "Barua pepe", password: "Nywila",
    username: "Jina la mtumiaji", rememberMe: "Nikumbuke", forgotPassword: "Umesahau nywila?",
    signIn: "Ingia", signingIn: "Inaingia...", welcomeBack: "Karibu tena",
    loginSubtitle: "Ingia ili kufikia eneo lako la kazi la kampuni",
    language: "Lugha", theme: "Mandhari", search: "Tafuta",
    save: "Hifadhi", cancel: "Ghairi", create: "Tengeneza", edit: "Hariri", delete: "Futa",
    disable: "Zima", enable: "Washa", view: "Angalia", actions: "Vitendo", status: "Hali",
    active: "Hai", inactive: "Haifanyi kazi", confirm: "Thibitisha", close: "Funga",
    export: "Pakua CSV", filter: "Chuja", all: "Zote", loading: "Inapakia...",
    name: "Jina", phone: "Simu", location: "Mahali", address: "Anwani",
    description: "Maelezo", createdDate: "Tarehe ya Kutengenezwa", lastLogin: "Kuingia Mwisho",
    dashboard: "Dashibodi", organization: "Shirika", branches: "Matawi",
    orgProfile: "Wasifu wa Shirika", usersAccess: "Watumiaji na Ufikiaji", users: "Watumiaji",
    roles: "Majukumu", permissions: "Ruhusa", accessControl: "Udhibiti wa Ufikiaji",
    monitoring: "Ufuatiliaji", auditLogs: "Kumbukumbu za Ukaguzi", reports: "Ripoti",
    configuration: "Usanidi", settings: "Mipangilio", generalSettings: "Mipangilio ya Jumla",
    notifications: "Arifa", security: "Usalama", support: "Msaada",
    systemInfo: "Taarifa za Mfumo", profile: "Wasifu", myProfile: "Wasifu Wangu",
    totalBranches: "Jumla ya Matawi", activeBranches: "Matawi Yanayofanya Kazi",
    totalUsers: "Jumla ya Watumiaji", activeUsers: "Watumiaji Hai", inactiveUsers: "Watumiaji Wasiofanya Kazi",
    recentLogins: "Kuingia kwa Hivi Karibuni", failedLogins: "Kuingia Kulikoshindwa", recentActivity: "Shughuli za Hivi Karibuni",
    usersByBranch: "Watumiaji kwa Tawi", activeVsInactive: "Hai dhidi ya Wasiofanya Kazi",
    loginActivity: "Shughuli za Kuingia (siku 7)", todayActivity: "Shughuli za Leo",
    branchUsers: "Watumiaji wa Tawi", executiveOverview: "Muhtasari wa Utendaji",
    orgWideInsights: "Takwimu na vipimo vya shirika zima",
    salesInventory: "Mauzo na Bohari", products: "Bidhaa", sales: "Mauzo", inventory: "Bohari",
    newSale: "Uuzaji Mpya", createProduct: "Ongeza Bidhaa", editProduct: "Hariri Bidhaa",
    sku: "SKU", category: "Aina", brand: "Chapa", price: "Bei", cost: "Gharama", stock: "Hisa", reorderLevel: "Kiwango cha Kuagiza",
    lowStock: "Hisa Ndogo", totalProducts: "Jumla ya Bidhaa", totalSales: "Jumla ya Mauzo", revenue: "Mapato",
    todayRevenue: "Mapato ya Leo", todaySales: "Mauzo ya Leo", topProducts: "Bidhaa Zinazouzwa Zaidi",
    revenueByBranch: "Mapato kwa Tawi", salesTrend: "Mwenendo wa Mauzo (siku 7)", recentSales: "Mauzo ya Hivi Karibuni",
    invoice: "Ankara", customer: "Mteja", paymentMethod: "Malipo", quantity: "Idadi", total: "Jumla",
    addItem: "Ongeza", cart: "Kikapu", completeSale: "Kamilisha Mauzo", noProducts: "Hakuna bidhaa.", noSales: "Hakuna mauzo bado.",
    adjustStock: "Rekebisha Hisa", salesOverview: "Muhtasari wa mauzo na bohari", items: "Bidhaa", soldBy: "Aliyeuza", voidSale: "Futa Mauzo",
    branchManagement: "Usimamizi wa Matawi", createBranch: "Tengeneza Tawi",
    editBranch: "Hariri Tawi", branchCode: "Msimbo wa Tawi", branchName: "Jina la Tawi",
    manager: "Meneja", noBranches: "Hakuna matawi yaliyotengenezwa bado.",
    userManagement: "Usimamizi wa Watumiaji", createUser: "Tengeneza Mtumiaji", editUser: "Hariri Mtumiaji",
    firstName: "Jina la Kwanza", lastName: "Jina la Ukoo", role: "Jukumu", branch: "Tawi",
    confirmPassword: "Thibitisha Nywila", resetPassword: "Weka upya Nywila",
    assignRole: "Kabidhi Jukumu", assignBranch: "Kabidhi Tawi", noUsers: "Hakuna watumiaji.",
    roleManagement: "Usimamizi wa Majukumu", createRole: "Tengeneza Jukumu", editRole: "Hariri Jukumu",
    roleName: "Jina la Jukumu", systemRole: "Jukumu la Mfumo", customRole: "Jukumu Maalum",
    organizationView: "Mtazamo wa Shirika", currentBranch: "Tawi la Sasa",
    switchBranch: "Badilisha Tawi", viewAsBranch: "Angalia kama Tawi",
    superAdminViewing: "MSIMAMIZI MKUU — ANAANGALIA",
    selectBranch: "Chagua Tawi", selectBranchDesc: "Chagua tawi ili kuendelea",
    noNotifications: "Hakuna arifa.", noAuditRecords: "Hakuna kumbukumbu za ukaguzi.",
    markAllRead: "Weka zote kama zimesomwa", changePassword: "Badilisha Nywila",
    currentPassword: "Nywila ya Sasa", newPassword: "Nywila Mpya",
    accountStatus: "Hali ya Akaunti", version: "Toleo", environment: "Mazingira",
    databaseStatus: "Hali ya Hifadhidata", authStatus: "Hali ya Uthibitishaji", serverTime: "Muda wa Seva",
  },
};
